import dotProp from 'dot-prop'
import React from 'react'

import ObjectField from 'react-jsonschema-form/lib/components/fields/ObjectField'
import { connect } from 'react-redux'

import { actions } from "react-redux-form"
import { getPersistedEntities } from 'selectors/entities'

import { getUiOptions } from 'selectors/forms'
import { Dropdown, Form } from 'semantic-ui-react'
import underscored from 'underscore.string/underscored'

class SemanticSimplePolymorphicSelectorField extends ObjectField {
  render() {
    const {
      name,
      required,
      readonly,
      entityId,
      entityType,
      selectOptions,
    } = this.props;

    const selectedOption = selectOptions.find((option) => option.value === `${entityType}#${entityId}` )
    return (
      <Form.Field>
        {this.props.name === "id" ? <label htmlFor={name}>{I18n.t(underscored(this.props.translationScope))}{required ? "*" : null}</label>
        : <label htmlFor={this.props.name}>{I18n.t(`${this.props.translationScope}.${underscored(name)}`)}{required ? "*" : null}</label> }
        {readonly ?
          selectedOption && selectedOption.text || I18n.t('generic.unknown')
          : <React.Fragment>
            <Dropdown selection search options={selectOptions} onChange={this.props.handleChange}
                      value={selectedOption?.value} fluid />
          </React.Fragment>
        }

      </Form.Field>
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {

  var entityModel = `${ownProps.model || ''}.${ownProps.name}`
  let selectedEntityTypeModel = `${ownProps.model || ''}.${ownProps.name.replace('Id','')}Type`

  let options = ownProps.uiSchema["ui:options"];

  return {
    handleChange: (event, props) => {
      if (options.onSelect) dispatch(options.onSelect(props.value))
      let type = props.value.split('#')[0]
      let id = props.value.split('#')[1]

      dispatch(actions.change(entityModel, id))
      dispatch(actions.change(selectedEntityTypeModel, type))
    }
  }
}

const mapStateToProps = (state, ownProps) => {
  var options = getUiOptions(state,ownProps)


  var entityModel = `${ownProps.model || ''}.${ownProps.name}`
  let entityTypeModel = `${ownProps.model || ''}.${ownProps.name.replace('Id','')}Type`

  var entityId = dotProp.get(state, entityModel)
  var entityType = dotProp.get(state, entityTypeModel)

  let types = options.types

  let optionsToDisplay = types.flatMap((type) => {
    const { displayAttribute, valueAttribute, selector, entityName } = type

    // options for dropdown are derived from entities
    let entities;
    if(selector) {
      entities = selector.call(null, state);
    } else {
      entities = getPersistedEntities(entityName)(state, ownProps);
    }

    return entities.map(mapEntitiesToSelectableOptions(displayAttribute, valueAttribute, entityName))
  })

  return {
    entityId: entityId,
    entityType: entityType,
    selectOptions: optionsToDisplay,
  }
}

const mapEntitiesToSelectableOptions = (displayAttribute, valueAttribute, type) =>
{
  return entity => {
    let capitalizedType =  type.charAt(0).toUpperCase() +  type.slice(1)

    let text = ''
    if (typeof displayAttribute === "function") {
      text = displayAttribute.call(null, entity)
    } else {
      text = entity[displayAttribute]
    }

    let value;
    if (typeof valueAttribute === "function") {
      value = valueAttribute.call(null, entity)
    } else {
      value = entity[valueAttribute || "id"]
    }

    return {key: entity.id, value: `${capitalizedType}#${value}`, text: text}
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SemanticSimplePolymorphicSelectorField);
